module.exports = __webpack_public_path__ + "img/4.647fb9f7.png";